import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const images = [
  { src: "/images/3durinarysystem.webp", title: "3durinarysystem", alt: "3D labeled view of the urinary system" },
  { src: "/images/robotic_surgeron.jpg", title: "dr srikanth robotic_surgeron", alt: "Dr. Srikanth performing robotic surgery" },
  { src: "/images/robotic_sur1.jpg", title: "robotic_sur1", alt: "Robotic surgery setup in the operating room" },
  { src: "/images/clinic_img.png", title: "clinic_img", alt: "Interior of Dr. Srikanth's Urology Clinic" },
  { src: "/images/urology.jpg", title: "detailed urinary diagram", alt: "Detailed diagram of the urinary tract system" },
];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className="relative w-full h-screen overflow-hidden flex items-center justify-center">
      {/* Image Container */}
      <div
        className="flex transition-transform duration-700 ease-in-out w-full h-full"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((image, index) => (
          <figure key={index} className="w-full h-full min-w-full">
            <img
              src={image.src}
              alt={image.alt}
              loading="lazy"
              className={`w-full h-full object-cover ${imageLoaded ? '' : 'opacity-0'}`}
              onLoad={handleImageLoad}
            />
            <figcaption className="sr-only">{image.alt}</figcaption>
          </figure>
        ))}
      </div>

      {/* Previous Button */}
      <button
        onClick={prevSlide}
        className="absolute left-2 sm:left-5 top-1/2 transform -translate-y-1/2 p-2 sm:p-4 bg-gray-800 text-white rounded-full shadow-lg opacity-50 hover:opacity-100"
        aria-label="Previous Slide"
      >
        <ChevronLeft className="w-8 h-8 sm:w-10 sm:h-10" />
      </button>

      {/* Next Button */}
      <button
        onClick={nextSlide}
        className="absolute right-2 sm:right-5 top-1/2 transform -translate-y-1/2 p-2 sm:p-4 bg-gray-800 text-white rounded-full shadow-lg opacity-50 hover:opacity-100"
        aria-label="Next Slide"
      >
        <ChevronRight className="w-8 h-8 sm:w-10 sm:h-10" />
      </button>
    </div>
  );
};

export default ImageSlider;
